export const HERO_CONSTANTS = {
  button: {
    label: "Deploy your private Kubernetes clusters today",
    link: "#contact-us",
  },
  content:
    "Deploy fully isolated, private Kubernetes clusters for containerized applications with uncompromised security, flexibility, and automation.",
  title: "Secure & Scalable Kubernetes for Private Deployments",
};
